import type { BlogPost, Project, SearchResult } from '@/types';

export const searchContent = (
  query: string,
  posts: BlogPost[],
  projects: Project[],
): SearchResult[] => {
  if (!query.trim()) return [];

  const normalizedQuery = query.toLowerCase().trim();
  const results: SearchResult[] = [];

  for (const post of posts) {
    const searchable =
      `${post.title} ${post.excerpt} ${post.tags.join(' ')} ${post.category}`.toLowerCase();
    if (searchable.includes(normalizedQuery)) {
      results.push({
        type: 'blog',
        id: post.id,
        title: post.title,
        description: post.excerpt,
        url: `/blog/${post.slug}`,
      });
    }
  }

  for (const project of projects) {
    const searchable =
      `${project.title} ${project.description} ${project.techStack.join(' ')} ${project.category}`.toLowerCase();
    if (searchable.includes(normalizedQuery)) {
      results.push({
        type: 'project',
        id: project.id,
        title: project.title,
        description: project.description,
        url: `/projects#${project.id}`,
      });
    }
  }

  return results;
};
